import { Component } from '@angular/core';
import { SidenavService } from 'src/app/services/sidenav.service';
import { TermsAndConditionsService } from 'src/app/services/terms-and-conditions.service';

@Component({
  selector: 'app-hamburger-button',
  standalone: false,
  templateUrl: './hamburger-button.component.html',
  styleUrl: './hamburger-button.component.scss'
})
export class HamburgerButtonComponent {

  constructor(
    public readonly sidenavService: SidenavService,
    public readonly tecService: TermsAndConditionsService
  ) { }

  handleClick() {
    if (!this.tecService.isTermsAndConditionConfirmed()) {
      return;
    }
    this.sidenavService.toggle();
  }

}
